/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum Uitstroommoment {
    EINDE_SCHOOLJAAR = "Einde schooljaar",
    TUSSENTIJDS = "Tussentijds"
}
